module.exports = __webpack_public_path__ + "img/500.0312e316.jpg";